import React from "react";
import {WingBlank} from "antd-mobile";

const helpVideoUrl ='/publish/newmcc/tutorials-detail.php?video=108'

export default function Help(){
    return <WingBlank>
        <p>Metro’s Client Relations<br/>
            Phone: <a href="tel:8002231600">800-223-1600</a><br/>
            Email: <a href="mailto:service@metro-email.com?Subject=MiAD%20Wizard%20help">service@metro-email.com</a><br/>
            Click <a href={helpVideoUrl}>here</a>  for a video tutorial</p>
    </WingBlank>
}